// extracted by mini-css-extract-plugin
export default {"button":"OpenCloseButton_button__8CP5+"};